<template>
    <div>
        <p>邮箱：3437759879@qq.com</p>
        <p>联系电话：18751586680</p>
        <p style="font-size: x-small;display: flex; position: relative;margin-left: auto;margin-top: auto;">*本页面仅为校内试做，无商业用途</p>
    </div>
</template>

<style scoped>
*{
    box-sizing: border-box;
}
div{
display: flex;
flex-direction: column;
position: relative;
padding: 2rem 2rem;
height: 12rem;
background-color: var(--foot-bg,#f0f0f0);
font-weight: 300;
border-top: 0.1rem solid rgba(0, 0, 0, 0.2);
color: var(--foot-text,black);
transition: all 0.5s ease;
}
@media(max-width:50rem){
    div{
        height: 10rem;
    }
}
</style>